import { Component } from '@angular/core';
import { SessionService } from '../../../_services/session/session.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import ISale from '../../../_interfaces/ISale';
import { DeleteBase } from '../../../_classes/delete-base.class';
import { Observable } from 'rxjs';
import { EResources } from '../../../_resources/EResources';
import { SalesService } from '../../../_services/sales/sales.service';

@Component({
  selector: 'app-delete-button-sale',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: './delete-button-sale.component.html',
  styleUrl: './delete-button-sale.component.scss',
})
export class DeleteButtonSaleComponent extends DeleteBase<ISale> {
  constructor(
    public session: SessionService,
    public messageService: MessageService,
    public confirmationService: ConfirmationService,
    public tranlsate: TranslateService,
    public salesService: SalesService
  ) {
    super(session, confirmationService, messageService, tranlsate);
  }

  delete(): Observable<any> {
    return this.salesService.delete(
      this.customers_id,
      this.sites_id,
      this.payload.id
    );
  }

  getResourceName(): string {
    return EResources.SALES;
  }
}
